/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Attachment } from '../../models/attachment';

export interface List$Params {
  entityId: string;
  secondaryType?: string;
  entityClass: 'BulkPrintRequest' | 'FormQualityEntry' | 'FormRiskEntry' | 'FormSnapshotRequest' | 'FormCustom';
}

export function list(
  http: HttpClient,
  rootUrl: string,
  params: List$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<Attachment>>> {
  const rb = new RequestBuilder(rootUrl, list.PATH, 'get');
  if (params) {
    rb.path('entityId', params.entityId, {});
    rb.query('secondaryType', params.secondaryType, {});
    rb.path('entityClass', params.entityClass, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Attachment>>;
    })
  );
}

list.PATH = '/attachments/{entityClass}/{entityId}';
